export const getLanguageColor = (language = '') => {
  const lang = language.toLowerCase();
  
  const colors = {
    javascript: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20',
    js: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20',
    php: 'bg-indigo-500/10 text-indigo-400 border-indigo-500/20',
    css: 'bg-pink-500/10 text-pink-400 border-pink-500/20',
    scss: 'bg-pink-500/10 text-pink-400 border-pink-500/20',
    html: 'bg-orange-500/10 text-orange-400 border-orange-500/20',
    python: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
    bash: 'bg-slate-500/10 text-slate-400 border-slate-500/20',
    sh: 'bg-slate-500/10 text-slate-400 border-slate-500/20',
    json: 'bg-cyan-500/10 text-cyan-400 border-cyan-500/20',
    typescript: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
    ts: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
    react: 'bg-sky-500/10 text-sky-400 border-sky-500/20',
  };

  return colors[lang] || 'bg-indigo-500/10 text-indigo-400 border-indigo-500/20';
};